<template>
	<div class="sp">
		<div class="sp__elm">
			<div class="sp__elm-alert">Оплата прошла успешно!</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class SuccessPayment extends Vue {}
</script>

<style scoped lang="scss">
.sp {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		display: flex;
		justify-content: center;
	}

	&__elm-alert {
		color: rgb(26, 143, 70);
		font-size: 24px;
		font-weight: 600;
	}

	@media screen and (max-width: 768px) {
		&__elm-alert {
			font-size: 22px;
		}
	}
}
</style>
